/* eslint-disable react/jsx-no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

import Spinner from '~/components/spinner';
import ContainerFlex from '~/components/containerFlex';
import Grid from '~/components/grid';
import Input from '~/components/input';
import Button from '~/components/button';
import Loading from '~/components/loading';
import TextArea from '~/components/textarea';
import Dialog from '~/components/dialog';

import Endpoints from '~/services/endpoints';
import ConsultTransactionDetailResponse from '~/services/consult/transaction/detail/response';
import ConsultTransactionDetailPayload from '~/services/consult/transaction/detail/payload';

import { FormField, setFormState } from '~/utils/form';
import * as Masks from '~/utils/masks';

import useApi, { ApiMethod } from '~/hooks/useApi';

import { icons } from '~/assets';
import * as St from './styles';
import { transformInGlobalDate } from '~/utils/date';
import InstallmentsTransactionsResponse from '~/services/consult/transaction/installments/response';
import Container from '~/components/container';

interface LocationState {
  cpf?: FormField;
  numeroCartao?: FormField;
  idTransacao?: string;
  aberta: string;
}

interface Form {
  cIdOperador?: string;
  cCelular?: FormField;
  cCpf?: FormField;
  cDataVencimentoFatura?: FormField;
  cNome?: FormField;
  cNumeroCartao?: FormField;
  cStatusCartao?: FormField;
  cStatusFatura?: FormField;
  cDisputaPendente?: boolean;
  cDisputaEstornada?: boolean;
  tDataTransacao?: FormField;
  tDebitoCredito?: FormField;
  tDescricao?: FormField;
  tEstabelecimento?: FormField;
  tLocalPagamento?: FormField;
  tOrigemPagamento?: FormField;
  tHoraTransacao?: FormField;
  tIdTransacao?: FormField;
  tNumeroParcelas?: FormField;
  tTipo?: FormField;
  tValor?: FormField;
}

const ConsultTransactionDetailAgreementCard = (): JSX.Element => {
  const [reason, setReason] = useState('');
  const [reasonError, setReasonError] = useState(null);
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [dialoagInstallments, setDialoagInstallments] = useState(false);
  const [dialogInformativeIsOpen, setDialogInformativeIsOpen] = useState(false);
  const [dialogInformativetText, setInformativetText] = useState('');
  const [form, setForm] = useState<Form>({
    cCelular: { name: 'cCelular', value: '' },
    cCpf: { name: 'cCpf', value: '' },
    cDataVencimentoFatura: { name: 'cDataVencimentoFatura', value: '' },
    cNome: { name: 'cNome', value: '' },
    cNumeroCartao: { name: 'cNumeroCartao', value: '' },
    cStatusCartao: { name: 'cStatusCartao', value: '' },
    cStatusFatura: { name: 'cStatusFatura', value: '' },
    tDataTransacao: { name: 'tDataTransacao', value: '' },
    tDebitoCredito: { name: 'tDebitoCredito', value: '' },
    tDescricao: { name: 'tDescricao', value: '' },
    tEstabelecimento: { name: 'tEstabelecimento', value: '' },
    tLocalPagamento: { name: 'localPagamento', value: '' },
    tOrigemPagamento: { name: 'origemPagamento', value: '' },
    tHoraTransacao: { name: 'tHoraTransacao', value: '' },
    tIdTransacao: { name: 'tIdTransacao', value: '' },
    tNumeroParcelas: { name: 'tNumeroParcelas', value: '' },
    tTipo: { name: 'tTipo', value: '' },
    tValor: { name: 'tValor', value: '' },
  });

  const location = useLocation<LocationState>();
  const history = useHistory();

  const api = useApi<ConsultTransactionDetailResponse>(
    Endpoints.consult.detailTransaction,
    ApiMethod.POST,
  );

  const RequestInstallmentsTransactions = useApi<InstallmentsTransactionsResponse>(
    Endpoints.consult.transactionInstallments,
    ApiMethod.POST,
    {
      idTransacao: location.state?.idTransacao,
      numeroCartao: location.state?.numeroCartao?.unmasked,
    },
  );

  const ResquestIncludeDispute = useApi(
    `${Endpoints.create.dispute}`,
    ApiMethod.POST,
    {
      idOperador: form.cIdOperador,
      motivoDisputa: reason,
      numeroCartao: form.cNumeroCartao.value,
      transacao: {
        idTransacao: location.state?.idTransacao,
        valor: form.tValor.value,
        data: transformInGlobalDate(form.tDataTransacao.value),
        horario: form.tHoraTransacao.value,
        loja: form.tEstabelecimento.value,
        quantidadeParcelas: form.tNumeroParcelas.value,
        tipoTransacao: form.tTipo.value,
      },
    },
  );

  useEffect(() => {
    searchDetail();
  }, []);

  useEffect(() => {
    if (api.data) {
      loadData();
    }
  }, [api.loading]);

  const searchDetail = () => {
    const payload: ConsultTransactionDetailPayload = {
      idTransacao: location.state?.idTransacao,
      cpf: location.state?.cpf?.unmasked,
      numeroCartao: location.state?.numeroCartao?.unmasked,
      tipoCartao: 'CONVENIO',
    };

    api.callApi(payload);
  };

  const getStatusData = (value: string) => {
    return value === '1' ? 'Aberta' : 'Fechada';
  };

  const loadData = () => {
    const data = api.data as ConsultTransactionDetailResponse;

    const telefone = Masks.phoneMask(Masks.phoneUnmask(data.cliente?.celular));
    const dtVenc = Masks.dateMask(
      Masks.dateUnmask(String(data?.cliente?.dataVencimentoFatura)),
    );

    if (data.disputaPendente) setReason('Já foi salvo');

    const obj: Form = {
      cIdOperador: localStorage.getItem('USER_ID'),
      cCelular: {
        ...form.cCelular,
        value: telefone.masked,
        unmasked: telefone.unmasked,
      },
      cDisputaPendente: data.disputaPendente || false,
      cDisputaEstornada: data.disputaEstornada || false,
      cCpf: {
        ...form.cCpf,
        value: Masks.cpfMask(data?.cliente?.cpf).masked,
        unmasked: Masks.cpfMask(data?.cliente?.cpf).unmasked,
      },
      cDataVencimentoFatura: {
        ...form.cDataVencimentoFatura,
        value: dtVenc.masked,
        unmasked: dtVenc.unmasked,
      },
      cNome: { ...form.cNome, value: data?.cliente?.nome },
      cNumeroCartao: {
        ...form.cNumeroCartao,
        value: data?.cliente?.numeroCartao,
      },
      cStatusCartao: {
        ...form.cStatusCartao,
        value: data?.cliente.statusCartao,
      },
      cStatusFatura: {
        ...form.cStatusFatura,
        value: getStatusData(location.state?.aberta),
      },
      tDataTransacao: {
        ...form.tDataTransacao,
        value: data?.transacao?.dataTransacao?.split(' ')[0],
      },
      tDebitoCredito: {
        ...form.tDebitoCredito,
        value: data?.transacao?.debitoCredito,
      },
      tDescricao: { ...form.tDescricao, value: data?.transacao?.descricao },
      tEstabelecimento: {
        ...form.tEstabelecimento,
        value: data?.transacao?.estabelecimento,
      },
      tLocalPagamento: {
        ...form.tLocalPagamento,
        value: data?.transacao?.localPagamento,
      },
      tOrigemPagamento: {
        ...form.tOrigemPagamento,
        value: data?.transacao?.origemPagamento,
      },
      tHoraTransacao: {
        ...form.tHoraTransacao,
        value: data?.transacao?.horaTransacao,
      },
      tIdTransacao: {
        ...form.tIdTransacao,
        value: data?.transacao?.idTransacao,
      },
      tNumeroParcelas: {
        ...form.tNumeroParcelas,
        value: data?.transacao?.numeroParcelas,
      },
      tTipo: { ...form.tTipo, value: data?.transacao?.tipo },
      tValor: { ...form.tValor, value: data?.transacao?.valor },
    };

    setForm(obj);
  };

  const onClickOpenInstallmentPouUp = () => {
    setDialoagInstallments(true);
    RequestInstallmentsTransactions.callApi();
  };

  const goBack = () => history.goBack();

  const onClickIncludeDispute = (): void => {
    if (!reason.trim().length)
      return setReasonError('Prencha o campo corretamente.');

    setReasonError(null);
    setDialogIsOpen(true);
  };

  const handleIncludeDispute = async () => {
    setDialogIsOpen(false);
    const response = await ResquestIncludeDispute.callApi();

    if (response.status === 201 || response.status === 200) {
      setInformativetText('Transação incluida com sucesso!');
    } else {
      setInformativetText('Erro ao incluir transação.');
    }

    setDialogInformativeIsOpen(true);
  };

  return (
    <>
      <Loading status={api.loading || ResquestIncludeDispute.loading} />
      <Dialog
        icon={icons.confirmation}
        open={dialogIsOpen}
        negativeLabel="Cancelar"
        negativeAction={() => setDialogIsOpen(false)}
        positiveLabel="Confirmar"
        positiveAction={handleIncludeDispute}
        message="Deseja incluir essa proposta para disputa ?"
      />
      <Dialog
        icon={icons.confirmation}
        open={dialogInformativeIsOpen}
        positiveLabel="Entendi"
        positiveAction={() => history.push('/consult/transaction')}
        message={dialogInformativetText}
      />
      <Dialog
        icon={icons.exclamation}
        open={dialoagInstallments}
        title={<span style={{ color: 'red' }}> Parcelas </span>}
        positiveLabel="Voltar"
        positiveAction={() => setDialoagInstallments(false)}
      >
        {RequestInstallmentsTransactions.loading ? (
          <ContainerFlex center>
            <Spinner />
          </ContainerFlex>
        ) : (
          <St.Table>
            <tr>
              <th>N° Parcela </th>
              <th>Valor</th>
              <th style={{ borderRight: '1px solid grey' }}>Data vencimento</th>
            </tr>
            {RequestInstallmentsTransactions.data?.data?.map((installment) => (
              <tr>
                <td>{installment.parcela}</td>
                <td>
                  R$
                  {Masks.currencyMask(Number(installment.valor))}
                </td>
                <td style={{ borderRight: '1px solid grey' }}>
                  {moment(installment.vencimento).format('DD/MM/YYYY')}
                </td>
              </tr>
            ))}
          </St.Table>
        )}
      </Dialog>

      <Container>
        <St.BoxCard>
          <ContainerFlex color="#fbfbfb">
            <St.TitleCategory>1. Cliente</St.TitleCategory>
          </ContainerFlex>

          <ContainerFlex padding={26}>
            <Grid xs={1} lg={2} gap={30}>
              <ContainerFlex>
                <Input
                  label="Número do cartão"
                  value={Masks.creditCardMask(form.cNumeroCartao.value).masked}
                  name={form.cNumeroCartao.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
                <Input
                  label="Nome completo"
                  value={form.cNome.value}
                  name={form.cNome.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
                <Input
                  label="CPF"
                  value={form.cCpf.value}
                  name={form.cCpf.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
              </ContainerFlex>

              <ContainerFlex>
                <Input
                  label="Data de vencimento da fatura do cartão"
                  value={form.cDataVencimentoFatura.value}
                  name={form.cDataVencimentoFatura.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
                <Input
                  label="Telefone"
                  value={form.cCelular.value}
                  name={form.cCelular.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
              </ContainerFlex>
            </Grid>
          </ContainerFlex>

          <ContainerFlex row center color="#fbfbfb">
            <St.TitleCategory>2. Transação</St.TitleCategory>
          </ContainerFlex>

          <ContainerFlex padding={26}>
            <Grid xs={1} lg={2} gap={30}>
              <ContainerFlex>
                <Input
                  label="ID da transação"
                  value={form.tIdTransacao.value}
                  name={form.tIdTransacao.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
                <Input
                  label="Valor da Parcela"
                  value={`R$${Masks.currencyMask(form.tValor.value)}`}
                  name={form.tValor.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />

                <div>
                  <ContainerFlex row>
                    <ContainerFlex marginRight={16}>
                      <Input
                        label="Data da transação"
                        value={form.tDataTransacao.value}
                        name={form.tDataTransacao.name}
                        onChange={(e) => setFormState(e, form, setForm)}
                        readOnly
                      />
                    </ContainerFlex>

                    <ContainerFlex>
                      <Input
                        label="Horário da transação"
                        value={form.tHoraTransacao.value}
                        name={form.tHoraTransacao.name}
                        onChange={(e) => setFormState(e, form, setForm)}
                        readOnly
                      />
                    </ContainerFlex>
                  </ContainerFlex>
                  <ContainerFlex>
                    <Input
                      label="Valor da Compra"
                      value={`R$${Masks.currencyMask(
                        Number(form.tValor.value) *
                          Number(form.tNumeroParcelas.value),
                      )}`}
                      name={form.tValor.name}
                      onChange={(e) => setFormState(e, form, setForm)}
                      readOnly
                    />
                  </ContainerFlex>
                </div>

                {/* <Input label="Empresa" value="" readOnly /> */}
              </ContainerFlex>

              <ContainerFlex>
                <Input
                  label="Local da transação"
                  value={
                    form.tTipo.value === 'PAGAMENTO_FATURA'
                      ? form.tLocalPagamento.value
                      : form.tEstabelecimento.value
                  }
                  name={form.tEstabelecimento.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
                {/* <Input label="Lojas cadastradas" value="" readOnly /> */}
                <Input
                  label="Tipo de transação"
                  value={form.tTipo.value}
                  name={form.tTipo.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
                <Input
                  label="Quantidade de parcelas"
                  value={form.tNumeroParcelas.value}
                  name={form.tNumeroParcelas.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
                <Input
                  label="Descrição"
                  value={form.tDescricao.value}
                  name={form.tDescricao.name}
                  onChange={(e) => setFormState(e, form, setForm)}
                  readOnly
                />
              </ContainerFlex>
            </Grid>
          </ContainerFlex>

          {/* <ContainerFlex marginTop={20} marginLeft={26}>
            <Button fitContent onClick={onClickOpenInstallmentPouUp}>
              Ver parcelas
            </Button>
          </ContainerFlex> */}

          <ContainerFlex padding={26}>
            <TextArea
              placeholder="Informe o motivo.."
              rows={10}
              onChange={(e) => setReason(e.target.value)}
              errorMessage={reasonError}
              readOnly={form.cDisputaPendente}
              value={reason}
            />
          </ContainerFlex>

          <ContainerFlex row end padding={24}>
            <Button onClick={goBack} outlined>
              Voltar
            </Button>
            <Button
              marginLeft={16}
              onClick={onClickIncludeDispute}
              disabled={
                form.cDisputaPendente ||
                form.cDisputaEstornada ||
                form.cStatusCartao.value !== 'ATIVO' ||
                form.cStatusFatura.value === 'Fechada'
              }
            >
              Incluir Disputa
            </Button>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </>
  );
};

export default ConsultTransactionDetailAgreementCard;
